import { render, staticRenderFns } from "./driverInfoComponent.vue?vue&type=template&id=486903a2&scoped=true&"
import script from "./driverInfoComponent.vue?vue&type=script&lang=js&"
export * from "./driverInfoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486903a2",
  null
  
)

export default component.exports